"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AVPermissionsModal = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Modal = require("../Modals/Modal.styled");
var _AVPermissionsModal = require("./AVPermissionsModal.styled");
var _ = require("./..");
var AVPermissionsModal = exports.AVPermissionsModal = function AVPermissionsModal(_ref) {
  var error = _ref.error,
    isOpen = _ref.isOpen,
    isMobile = _ref.isMobile,
    handleClick = _ref.handleClick;
  return _react["default"].createElement(_Modal.StyledMobileStyledModal, {
    isOpen: isOpen,
    fade: !isMobile
  }, _react["default"].createElement(_AVPermissionsModal.StyledModalHeader, null, !error ? _react["default"].createElement("b", null, "Permission to access microphone") : _react["default"].createElement("b", null, "Please change your browser permissions")), _react["default"].createElement(_AVPermissionsModal.StyledModalBody, null, !error ? _react["default"].createElement("p", null, "Before anyone else can hear you, we need you to allow Studio permission to access your microphone.") : _react["default"].createElement("p", null, "Your browser is blocking access to your microphone. Check your browser preferences to grant Studio permission. Please follow the steps in this article to correctly configure your browser."), _react["default"].createElement(_AVPermissionsModal.StyledButtonsWrapper, null, _react["default"].createElement(_.Button, {
    onClick: handleClick,
    "data-testid": "request-permissions-button"
  }, !error ? 'Request permission' : 'Learn more'))));
};
AVPermissionsModal.propTypes = {
  error: _propTypes["default"].string,
  isOpen: _propTypes["default"].bool,
  isMobile: _propTypes["default"].bool,
  handleClick: _propTypes["default"].func.isRequired
};
AVPermissionsModal.defaultProps = {
  isOpen: false,
  isMobile: false
};